export const consciousnessLevels = [
  {
    value: "A",
    label: "Alert",
    color: "#8BC34A",
    tooltip: "Alert",
  },
  {
    value: "C",
    label: "Confusion",
    color: "#FF9800",
    tooltip: "Confusion",
  },
  {
    value: "V",
    label: "Voice",
    color: "#FFC107",
    tooltip: "Responds to voice",
  },
  {
    value: "P",
    label: "Pain",
    color: "#FF5722",
    tooltip: "Responds to pain",
  },
  {
    value: "U",
    label: "Unresponsive",
    color: "#9E9E9E",
    tooltip: "Unresponsive",
  },
];

export const getRiskLevelColor = (riskLevel) => {
  switch (riskLevel) {
    case "Low":
      return "success";
    case "Medium":
      return "warning";
    case "High":
      return "error";
    default:
      return "default";
  }
};
